<template>
  <el-container>
    <el-main>
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <!--<el-form-item label="用户名" prop="name">-->
          <!--<el-input v-model.number="ruleForm.name"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="旧密码" prop="oldPass" required>
          <el-input type="password" v-model="ruleForm.oldPass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass" required>
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass" required>
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item class="el-form-item-btn">
          <el-button class="theme-btn" @click="submitForm('ruleForm')">确认修改</el-button>
          <!--<el-button @click="resetForm('ruleForm')">重置</el-button>-->
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: "InfoManage",
    props: [],
    data() {
      // 自定义的校验规则
      let checkName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('用户名不能为空'));
        }
        callback();
      };
      let checkOldPass = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('旧密码不能为空'));
        }
        if(this.tools.passwordCheck(value)){
          return callback(new Error('密码长度6-16位，至少包含字母、数字、符号其中2项'));
        }
        callback();
      };
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else {
          if(this.tools.passwordCheck(value)){
            return callback(new Error('密码长度6-16位，至少包含字母、数字、符号其中2项'));
          }
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入的新密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        // 表单数据
        ruleForm: {
          pass: '',
          checkPass: '',
          name: '',
          oldPass:''
        },
        // 表单校验
        rules: {
          pass: [
            {validator: validatePass, trigger: 'blur'}
          ],
          checkPass: [
            {validator: validatePass2, trigger: 'blur'}
          ],
          name: [
            {validator: checkName, trigger: 'blur'}
          ],
          oldPass: [
            {validator: checkOldPass, trigger: 'blur'}
          ]
        }
      };

    },
    created(){
      this.ruleForm.name = JSON.parse(localStorage["associationProfile"]).name;
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitModify()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      submitModify(){


        console.log(this.ruleForm);
        let param = {
          name: this.ruleForm.name,
          newPass: this.ruleForm.pass,
          oldPass:this.ruleForm.oldPass
        };
        console.log(param);
        this.$api.put('/user/profile/modify.json', param)
          .then(res => {
            this.$message({
              message: '修改成功,请重新登录！',
              type: 'success'
            });
            this.tools.pageRedirected('','/')
        }, err => {
          this.$message.error(err.msg)
        })
          .catch(err => {
            console.log(err);
            this.$message.error("修改异常!");
          })
      },
    }
  }

</script>

<style scoped>
  .el-main {
    display: flex;
    justify-content: center;
    padding-top: 50px;
  }

  .el-form {
    width: 400px;
  }

  .el-form-item-btn{
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/infoManage/InfoModify.vue